import Card from 'components/global/Card';
import Icon from 'components/global/Icon';
import Skeleton from 'components/global/Skeleton';
import Typography from 'components/global/Typography';

import { Divider } from './styled/Chart.styled';
import * as S from './styled/SummaryCard.styled';

const SummaryCard = ({ data, loading, card }) => (
	<Card className="p-5">
		<S.HeaderWrapper>
			<S.IconWrapper>
				<Icon icon={card.icon} size="medium" />
			</S.IconWrapper>
			<div>
				<Typography variant="p2" noWrap gutterBottom>
					{card.headerLabel}
				</Typography>
				{loading ? (
					<Skeleton width="5rem" height="2.2rem" />
				) : (
					<Typography variant="h4" fontWeight="700" withCurrency currency={data?.currency}>
						{data?.[card.prefix][card.dataKey]}
					</Typography>
				)}
			</div>
		</S.HeaderWrapper>
		<Divider />
		<S.DetailsWrapper>
			{card.details.map((detail, index) => (
				<div key={index}>
					<Typography variant="p2" noWrap gutterBottom>
						{detail.label}
					</Typography>
					{loading ? (
						<Skeleton width="5rem" height="2.2rem" />
					) : (
						<Typography variant="p1" fontWeight="700" withCurrency currency={data?.currency}>
							{data?.[card.prefix][detail.dataKey]}
						</Typography>
					)}
				</div>
			))}
		</S.DetailsWrapper>
	</Card>
);

export default SummaryCard;
